// hooks/useS3FileUpload.js
import { useState } from 'react';
import { SEC_DataApiPost, SEC_FileApiPost, fileUploadFormDataGenerator } from '../func';

export default function useS3FileUpload(folderPath) {
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const uploadFiles = async (files, userId, options = {}) => {
    setUploading(true);
    setUploadError(null);

    const timestamp = new Date().toISOString();
    const {
      requestId = null,
      uploadGroupId = null,
      formId = null,
      questionId = null,
    } = options;

    if (!requestId && !uploadGroupId) {
      throw new Error('Missing requestId or uploadGroupId for file upload.');
    }

    try {
      const uploadPromises = files.map(async (file) => {
        const uploadParams = {
          requestType: folderPath,
          fileName: file.fileName,
          fileSize: file.fileSize,
        };
        if (requestId) {
          uploadParams.locationId = requestId;
        }
        if (uploadGroupId) {
          uploadParams.uploadGroupId = uploadGroupId;
        }
        if (formId) {
          uploadParams.formId = formId;
        }
        if (questionId) {
          uploadParams.questionId = questionId;
        }

        const uploadUrlResponse = await SEC_DataApiPost('general/SignedURLs', '', uploadParams);
        let uploadUrl = uploadUrlResponse;
        if (typeof uploadUrl === 'string') {
          uploadUrl = JSON.parse(uploadUrl);
        }
        if (uploadUrl?.body) {
          uploadUrl = typeof uploadUrl.body === 'string' ? JSON.parse(uploadUrl.body) : uploadUrl.body;
        }
        if (uploadUrl?.data && typeof uploadUrl.data === 'string') {
          uploadUrl = JSON.parse(uploadUrl.data);
        }
        if (!uploadUrl?.url || !uploadUrl?.fields || !uploadUrl?.fileId) {
          console.error('Upload URL response payload:', uploadUrlResponse);
          throw new Error('Upload URL response is missing required fields.');
        }

        file.metadata = {
          originalname: file.fileName,
          submitted: timestamp,
          userid: userId,
        };

        const formData = fileUploadFormDataGenerator(uploadUrl, file);

        await SEC_FileApiPost(uploadUrl.url, formData, () => {
          throw new Error('File upload failed');
        });

        return {
          oldName: file.fileName,
          fileId: uploadUrl.fileId,
          size: file.fileSize,
          uploadTimestamp: timestamp,
        };
      });

      const uploadedFiles = await Promise.all(uploadPromises);
      setUploading(false);
      return uploadedFiles;

    } catch (error) {
      console.error('Upload error:', error);
      setUploading(false);
      setUploadError(error);
      throw error;
    }
  };

  return {
    uploadFiles,
    uploadState: { uploading, uploadError },
  };
}
